import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star, Clock, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative bg-[#FDFBF7] overflow-hidden" data-id="element-152">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-153">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-154">
          <defs data-id="element-155">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-156">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-157" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-158" />
        </svg>
      </div>

      <div className="container mx-auto px-4 pt-12 pb-20 md:pt-20 md:pb-28 relative z-10" data-id="element-159">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-160">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-161">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-6 border border-amber-200" data-id="element-162">
              <Star className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-163" />
              <span data-id="element-164">El Secreto de la Pastelería Francesa</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-stone-900 leading-tight mb-6" data-id="element-165">
              ¿Por qué el Mil Hojas de pastelería dura días crujiente y el tuyo
              se ablanda en{' '}
              <span className="text-amber-600 italic" data-id="element-166">20 minutos</span>?
            </h1>

            <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-167">
              Descubre el secreto del{' '}
              <strong className="text-stone-900" data-id="element-168">"Escudo de Cristal"</strong> y
              olvídate del hojaldre chicloso para siempre.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-4" data-id="element-169">
              <Button size="lg" className="w-full sm:w-auto text-lg shadow-amber-200/50" onClick={scrollToOffer} data-id="element-170">
                Obtener la Guía Maestra - $6.39
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-171" />
              </Button>
            </div>

            <p className="text-xs text-stone-400 text-center lg:text-left mb-6" data-id="element-172">
              Incluye bonos por tiempo limitado.
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 text-sm text-stone-500 font-medium" data-id="element-173">
              <div className="flex items-center gap-2" data-id="element-174">
                <Clock className="w-4 h-4 text-amber-600" data-id="element-175" />
                <span data-id="element-176">Lectura rápida</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-177">
                <ShieldCheck className="w-4 h-4 text-amber-600" data-id="element-178" />
                <span data-id="element-179">Técnica probada</span>
              </div>
            </div>
          </div>

          {/* Product Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-180">
            <div className="absolute inset-0 bg-amber-200 rounded-2xl rotate-3 transform scale-95 opacity-50 blur-xl" data-id="element-181"></div>
            <img src="https://cdn.magicpatterns.com/uploads/tw6KWHMb7t51djdwgghJH6/portada.png" alt="Mil Hojas Pro Guide on iPad" className="relative w-full h-auto rounded-xl shadow-2xl border-4 border-white transform hover:scale-[1.01] transition-transform duration-500" data-id="element-182" />

            {/* Float Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-xl border border-stone-100 hidden md:block" data-id="element-183">
              <div className="flex items-center gap-3" data-id="element-184">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-185">
                  <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-186" />
                </div>
                <div data-id="element-187">
                  <p className="text-xs text-stone-500 uppercase font-bold tracking-wider" data-id="element-188">
                    Resultado
                  </p>
                  <p className="text-stone-900 font-bold" data-id="element-189">100% Crujiente</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}